import { styled } from '@mui/material/styles';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

export const PluginTypeCard = styled(Card)(({ active, disabled, theme }) => ({
  width: '145px',
  height: '189px',
  background: disabled ? theme.palette.vpColors.greyLighter : theme.palette.vpColors.white,
  border: `1px solid ${
    active ? theme.palette.vpColors.blueMain : theme.palette.vpColors.greyLight
  }`,
  boxShadow: active ? '0px 0px 0px 5px rgba(33, 120, 246, 0.15)' : 'none',
  borderRadius: '6px'
}));

export const PluginTypeCardContent = styled(CardContent)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '145px',
  height: '153px'
});

export const PluginTypeCardFooter = styled(CardActions)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.vpColors.greyLight}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  width: '145px',
  height: '36px',
  ...theme.typography.body1
}));

export const FullWidthStack = styled(Stack)({
  width: '100%'
});

export const ModalContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '686px',
  borderRadius: '6px',
  backgroundColor: theme.palette.vpColors.white
}));

export const ModalHeader = styled('div')(({ theme }) => ({
  width: '100%',
  paddingTop: '7.5px',
  paddingBottom: '7.5px',
  paddingLeft: '22px',
  paddingRight: '22px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  border: `1px solid ${theme.palette.vpColors.greyLight}`
}));

export const ModalBody = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  paddingTop: '32px',
  paddingLeft: '26.5px',
  paddingRight: '26.5px'
});

export const ModalFooter = styled('div')({
  paddingTop: '32px',
  paddingBottom: '25px',
  paddingLeft: '26.5px',
  paddingRight: '26.5px'
});

export const Title = styled(Typography)({
  fontWeight: '500 !important',
  fontSize: '24px !important',
  paddingBottom: '12px'
});

export const SubTitle = styled(Typography)({
  maxWidth: '301px',
  padding: '0px'
});



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpCreatePluginDialog/styles.js